import React, { useEffect, useMemo } from 'react';
import CustomSelect from '../../components/CustomSelect';
import { invalidMap, invalidOptions } from '../../constants/invalid';
import {
  useGetCustomSelectButtonElement,
  useSetSelectDefaultValue,
} from '../../hooks/init';
import { SingleCommonType } from '../../types';
import { invalidPlaceholder } from '../../constants/placeholder';
import { commonBackInfo } from '../../utils';
import useLanguage from '@/pages/opinion/hooks/useLanguage';
import BubbleCommon, { commonValidationTips } from '../../../BubbleCommon';
import { NO_DATE } from '@/pages/opinion/constants';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';

export default function InvalidSelect({
  onChange,
  defaultValue,
  filterValue,
  defaultKey,
  lang,
  oriDefaultFilter,
  backOriDefaultValue,
}: SingleCommonType) {
  const {
    selects: invalidSelects,
    setSelects: setInvalidSelects,
    diffClassName,
  } = useSetSelectDefaultValue<string>({
    defaultValue,
    filterValue,
    oriDefaultFilter,
    backOriDefaultValue,
    defaultKey: 'is_valid',
    options: invalidOptions.map((item) => item.value),
    finallyDealwithSelected: (values: Array<any>) => values.map(String),
  });

  const { formatOptionsMessage, formatMessage } = useLanguage();

  const { customSelectRef, getButtonElement } =
    useGetCustomSelectButtonElement();

  useEffect(() => {
    const [text, isAll] = getButtonElement();
    onChange?.(
      'invalid',
      commonBackInfo(
        { is_valid: invalidSelects.map(Number) },
        { [defaultKey]: text },
        { needChangeEntity: true, isNumber: true, isAll },
      ),
    );
  }, [invalidSelects, formatMessage]);

  return (
    <div className={`invalid-select-wrapper ${diffClassName}`}>
      <BubbleCommon
        placement="left"
        showIcon={false}
        tipsMap={commonValidationTips}
      >
        <CustomSelect
          ref={customSelectRef}
          placeholderText={invalidPlaceholder[lang]}
          pointKey={FilterButtonPoint.invalid}
          onClear={() => setInvalidSelects([])}
          buttonItemRender={(item: string) =>
            formatMessage({ id: invalidMap[item] || NO_DATE.EMPTY })
          }
          showNumber={3}
          selectOptionsInfo={[invalidSelects, setInvalidSelects]}
          options={formatOptionsMessage(invalidOptions)}
        ></CustomSelect>
      </BubbleCommon>
    </div>
  );
}
